export const pickAddressByUse = (addresses, useId) => (
  addresses.find((address) => (
    address.addressUse.some((use) => use.id === useId)
  ))
)